import { createSlice } from "@reduxjs/toolkit";

const dataSlice = createSlice({
  name: "data",
  initialState: {
    dataPracticas: [
      {
        month: {
          id: "",
          name: "",
          value: {
            entresemana: [],
            findesemana: [],
          },
        },
      },
    ],
    elementoSeleccionadoEnPracticas: "",
    monthSelected: "",
    practicas: {
      tipo: "practicas",
      periodo: "entre_semana",
      personas: 1,
      data: {},
    },
    salidas: [],
    fetchingError: false,
    fetchingMessage: "",
    fetchingCode: 0,
    codeId: 0,
  },
  reducers: {
    // Hora del Servidor DD/MM/YYYY
    applyServerDate(state, action) {
      state.serverDate = action.payload;
    },
    applyDataPracticas(state, action) {
      state.dataPracticas = action.payload;
    },
    applyPracticasData(state, action) {
      state.practicasentresemana = action.payload.entresemana;
      state.practicasfindesamana = action.payload.findesemana;
    },
    applyPracticas(state, action) {
      state.practicas.periodo = action.payload.periodo;
      state.practicas.personas = action.payload.personas;
      state.practicas.data = action.payload.data;
    },
    elementoSeleccionadoEnPracticas(state, action) {
      state.elementoSeleccionadoEnPracticas = action.payload;
    },
    setMonthSelected(state, action) {
      state.monthSelected = action.payload;
    },
    setSalidas(state, action) {
      const elementExists = state.salidas.some(
        (o) => o.id === action.payload.data.id
      );
      if (!elementExists) {
        state.salidas.push(action.payload);
      }
    },
    removeSalidas(state, action) {
      state.salidas = state.salidas.filter((s) => s.id !== action.payload);
    },
    updateSalidas(state, action) {
      state.salidas = state.salidas.map((p) =>
        p.id == action.payload.id
          ? { ...p, personas: action.payload.personas }
          : p
      );
    },
    emptySalidas(state, action) {
      state.salidas = action.payload;
    },
    fetchingInfo(state, action) {
      state.fetchingError = action.payload.fetchingError;
      state.fetchingMessage = action.payload.fetchingMessage;
      state.fetchingCode = action.payload.fetchingCode;
      state.codeId = action.payload.codeId;
    },
  },
});

export const dataActions = dataSlice.actions;

export default dataSlice;
